import { useShopAvailability } from "../shopAvailability";
import { useSelector } from "react-redux";

//Components
import { Button } from "@delibrandev/utils";
import { useNavigate } from "react-router";

export const MakeOrderButton = ({ disabled = false, actionText, actionUrl, actionBackText = null, actionBackUrl = null }) => {
  const navigate = useNavigate();
  const { canOrder } = useShopAvailability();
  disabled = disabled || !canOrder;
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);
  const cart = useSelector((state) => state.aplicationConfig.userConfig.cart);

  return (
    <div className="order-commander-totals-resume-action">
      {!logged ? (
        <Button
          disabled={disabled}
          text={"Identifícate para continuar"}
          icon={null}
          customClass={"customButtonColor2 bigMobileButton"}
          action={() => navigate("/profile")}
        />
      ) : (
        <div className="flex-gap">
          <div className="mobileRender w-100">
            <div className="flex ">
              {actionBackText && actionBackUrl && (
                <div style={{ flex: "1" }}>
                  <Button text={actionBackText} icon={null} customClass={"customButtonColor1"} action={() => navigate(actionBackUrl)} />
                </div>
              )}
              <div className="order-action-url" style={!actionBackUrl ? { flex: "0 0 100%" } : { flex: "0 0 70%" }}>
                <Button
                  text={actionText}
                  icon={null}
                  customClass={"customButtonColor2"}
                  action={() => navigate(actionUrl)}
                  disabled={disabled || !cart?.ShoppingCartProducts?.length}
                />
              </div>
            </div>
          </div>
          <div className="desktopRender w-100">
            <div className="order-action-url" style={{ flex: "0 0 100%" }}>
              <Button
                text={actionText}
                icon={null}
                customClass={"customButtonColor2"}
                action={() => navigate(actionUrl)}
                disabled={disabled || !cart?.ShoppingCartProducts?.length}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
